module.exports = __webpack_public_path__ + "img/zip.957f6459.png";